export const allCategories = [
  { id: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，心动瞬间的完美演绎', comicCount: 2860 },
  { id: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '魔法与冒险交织的幻想世界，开启想象之旅', comicCount: 1940 },
  { id: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的战斗场面，力量与意志的碰撞', comicCount: 2150 },
  { id: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理悬疑，烧脑体验全程高能', comicCount: 1280 },
  { id: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默的日常喜剧，笑到停不下来', comicCount: 1630 },
  { id: 'rebirth', name: '重生', icon: 'ri-loop-right-line', description: '重生逆袭的爽文剧情，改写命运的精彩故事', comicCount: 1120 },
  { id: 'workplace', name: '职场', icon: 'ri-briefcase-line', description: '现代职场风云录，办公室里的爱恨情仇', comicCount: 890 },
  { id: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖漫画，胆小慎入的精彩故事', comicCount: 640 },
];

export const allComics = [
  {
    id: 1,
    title: '绝世神医',
    author: '李清晨',
    status: '连载中',
    chapter: '更新至第128话',
    chapters: 128,
    tag: '热门',
    tagColor: 'primary' as const,
    category: 'fantasy',
    description: '现代医学天才意外穿越至古代，凭借精湛医术和现代知识，在乱世中开创一番事业。从无人问津的小医馆，到声名远播的绝世神医，他用手术刀和银针书写了一段传奇人生。医术、权谋、爱情，交织成一幅波澜壮阔的画卷。',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20art%20style%20illustration%20of%20a%20handsome%20male%20doctor%20in%20traditional%20hanbok%20with%20modern%20twist%2C%20holding%20a%20golden%20acupuncture%20needle%2C%20dramatic%20lighting%2C%20soft%20warm%20gradient%20background%20with%20cherry%20blossom%20petals%2C%20romance%20and%20drama%20theme%2C%20digital%20art%20style%20with%20rich%20colors%20and%20detailed%20facial%20features%2C%20vertical%20composition%2C%20clean%20and%20elegant%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    chapters_list: [
      { num: 128, title: '最终决战', date: '2026-07-02' },
      { num: 127, title: '绝境重生', date: '2026-06-25' },
      { num: 126, title: '暗流涌动', date: '2026-06-18' },
      { num: 125, title: '棋差一招', date: '2026-06-11' },
      { num: 124, title: '真相浮出', date: '2026-06-04' },
      { num: 123, title: '暗中布局', date: '2026-05-28' },
      { num: 122, title: '步步紧逼', date: '2026-05-21' },
      { num: 121, title: '峰回路转', date: '2026-05-14' },
      { num: 120, title: '危机四伏', date: '2026-05-07' },
      { num: 119, title: '新的征程', date: '2026-04-30' },
    ],
    relatedIds: [2, 3, 4],
  },
  {
    id: 2,
    title: '暗夜王者',
    author: '金明勋',
    status: '连载中',
    chapter: '更新至第95话',
    chapters: 95,
    tag: '新番',
    tagColor: 'accent' as const,
    category: 'action',
    description: '地下世界的王者回归，昔日被背叛的黑道少主在黑暗中蛰伏多年后重新崛起。他游走于黑白两道之间，用智慧和铁腕一步步夺回属于自己的一切。在复仇与救赎的道路上，他遇见了改变他一生的那个女人。',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20featuring%20a%20mysterious%20dark-haired%20man%20in%20a%20luxurious%20black%20suit%2C%20standing%20in%20a%20modern%20city%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20dramatic%20shadows%2C%20action%20and%20thriller%20theme%2C%20digital%20illustration%20with%20moody%20atmosphere%2C%20vertical%20orientation%2C%20clean%20composition%20with%20soft%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    chapters_list: [
      { num: 95, title: '王者归来', date: '2026-07-01' },
      { num: 94, title: '最后一击', date: '2026-06-24' },
      { num: 93, title: '暗夜突袭', date: '2026-06-17' },
      { num: 92, title: '卧底身份', date: '2026-06-10' },
      { num: 91, title: '棋逢对手', date: '2026-06-03' },
      { num: 90, title: '步步为营', date: '2026-05-27' },
      { num: 89, title: '生死时速', date: '2026-05-20' },
      { num: 88, title: '暗中交易', date: '2026-05-13' },
      { num: 87, title: '血战到底', date: '2026-05-06' },
      { num: 86, title: '破晓时分', date: '2026-04-29' },
    ],
    relatedIds: [1, 4, 6],
  },
  {
    id: 3,
    title: '甜蜜陷阱',
    author: '朴秀妍',
    status: '连载中',
    chapter: '更新至第67话',
    chapters: 67,
    tag: '人气',
    tagColor: 'primary' as const,
    category: 'romance',
    description: '她只是一个普通的咖啡店店员，却意外卷入了一场财阀家族的继承权争夺战。两个截然不同的男人同时出现在她的生命中：一个是温柔体贴的咖啡店常客，另一个是冷酷高傲的财阀继承人。甜蜜的陷阱已经设下，她能否找到属于自己的真爱？',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20art%20of%20a%20lovely%20young%20woman%20with%20long%20flowing%20hair%2C%20wearing%20a%20pastel%20pink%20dress%2C%20surrounded%20by%20floating%20heart%20shapes%20and%20soft%20sparkles%2C%20romantic%20comedy%20theme%2C%20gentle%20warm%20lighting%20with%20pink%20and%20peach%20tones%2C%20digital%20art%20style%2C%20vertical%20composition%2C%20dreamy%20and%20sweet%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    chapters_list: [
      { num: 67, title: '真心告白', date: '2026-07-03' },
      { num: 66, title: '误会解除', date: '2026-06-26' },
      { num: 65, title: '意外的吻', date: '2026-06-19' },
      { num: 64, title: '情敌出现', date: '2026-06-12' },
      { num: 63, title: '深夜约会', date: '2026-06-05' },
      { num: 62, title: '心跳瞬间', date: '2026-05-29' },
      { num: 61, title: '雨中相遇', date: '2026-05-22' },
      { num: 60, title: '家族秘密', date: '2026-05-15' },
    ],
    relatedIds: [5, 1, 2],
  },
  {
    id: 4,
    title: '剑道至尊',
    author: '崔镇浩',
    status: '连载中',
    chapter: '更新至第203话',
    chapters: 203,
    tag: '连载',
    tagColor: 'secondary' as const,
    category: 'action',
    description: '在一座以剑为尊的大陆上，少年陆尘天生经脉尽断，被家族视为废柴抛弃。一次意外让他获得了上古剑圣的传承，从此踏上了一条逆天改命的剑道之路。以手中之剑，斩尽天下不平事。剑锋所向，万夫莫敌。',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20powerful%20swordsman%20in%20traditional%20martial%20arts%20attire%2C%20holding%20a%20glowing%20sword%2C%20standing%20on%20a%20mountain%20peak%20with%20dramatic%20clouds%20and%20sunset%20sky%2C%20action%20and%20cultivation%20theme%2C%20epic%20scale%2C%20digital%20art%20with%20vibrant%20warm%20colors%2C%20vertical%20orientation%2C%20clean%20and%20heroic%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    chapters_list: [
      { num: 203, title: '剑破苍穹', date: '2026-07-02' },
      { num: 202, title: '万剑归宗', date: '2026-06-25' },
      { num: 201, title: '天劫降临', date: '2026-06-18' },
      { num: 200, title: '第二百话贺礼', date: '2026-06-11' },
      { num: 199, title: '至尊对决', date: '2026-06-04' },
      { num: 198, title: '突破瓶颈', date: '2026-05-28' },
      { num: 197, title: '大战前夕', date: '2026-05-21' },
      { num: 196, title: '隐秘传承', date: '2026-05-14' },
    ],
    relatedIds: [6, 1, 2],
  },
  {
    id: 5,
    title: '办公室罗曼史',
    author: '韩智恩',
    status: '连载中',
    chapter: '更新至第42话',
    chapters: 42,
    tag: '推荐',
    tagColor: 'primary' as const,
    category: 'workplace',
    description: '新入职的市场部菜鸟林小薇，第一天上班就撞上了传闻中最严厉的部门总监。从最初的针锋相对到后来的默契配合，两个人的关系在工作的日常中悄然变化。办公室里的暧昧氛围，究竟是一时的好感还是命中注定的缘分？',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20of%20an%20elegant%20office%20couple%2C%20man%20and%20woman%20in%20stylish%20business%20attire%2C%20standing%20back%20to%20back%20with%20soft%20smiles%2C%20modern%20office%20background%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20romance%20drama%20theme%2C%20digital%20illustration%20with%20soft%20colors%2C%20vertical%20composition%2C%20clean%20and%20sophisticated%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    chapters_list: [
      { num: 42, title: '公开恋情', date: '2026-07-01' },
      { num: 41, title: '秘密被撞破', date: '2026-06-24' },
      { num: 40, title: '酒后真言', date: '2026-06-17' },
      { num: 39, title: '出差之夜', date: '2026-06-10' },
      { num: 38, title: '意外搭档', date: '2026-06-03' },
      { num: 37, title: '暧昧升级', date: '2026-05-27' },
      { num: 36, title: '第一次约会', date: '2026-05-20' },
    ],
    relatedIds: [3, 7, 1],
  },
  {
    id: 6,
    title: '灵异侦探社',
    author: '郑宇成',
    status: '连载中',
    chapter: '更新至第58话',
    chapters: 58,
    tag: '精品',
    tagColor: 'accent' as const,
    category: 'suspense',
    description: '拥有阴阳眼的大学生沈夜，在兼职送外卖时偶然闯入一家神秘的侦探社。从此，他开始接手各种超自然案件：闹鬼的公寓、诅咒的古玩、消失的房客……在破解一个个灵异事件的过程中，一个惊天阴谋也渐渐浮出水面。',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20mysterious%20detective%20with%20piercing%20eyes%2C%20wearing%20a%20long%20trench%20coat%2C%20holding%20a%20glowing%20lantern%20in%20a%20foggy%20alleyway%2C%20supernatural%20and%20mystery%20theme%2C%20cool%20blue-gray%20tones%20with%20warm%20lantern%20glow%2C%20digital%20art%20style%2C%20vertical%20orientation%2C%20atmospheric%20and%20suspenseful%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    chapters_list: [
      { num: 58, title: '最终档案', date: '2026-07-02' },
      { num: 57, title: '诅咒源头', date: '2026-06-25' },
      { num: 56, title: '亡者留言', date: '2026-06-18' },
      { num: 55, title: '地下迷宫', date: '2026-06-11' },
      { num: 54, title: '失踪的委托人', date: '2026-06-04' },
      { num: 53, title: '午夜来电', date: '2026-05-28' },
      { num: 52, title: '镜中世界', date: '2026-05-21' },
      { num: 51, title: '新案件', date: '2026-05-14' },
    ],
    relatedIds: [7, 8, 2],
  },
  {
    id: 7,
    title: '重生之商业帝国',
    author: '张俊赫',
    status: '连载中',
    chapter: '更新至第156话',
    chapters: 156,
    tag: '热读',
    tagColor: 'primary' as const,
    category: 'rebirth',
    description: '前世的商业奇才含恨而终，一朝重生回到1998年。带着未来二十年的记忆，他从一支被所有人看衰的互联网创业团队开始，投资未来的科技巨头，布局移动互联网，打造属于自己的商业帝国。而那个前世与他擦肩而过的女孩，这一次他绝不会再错过。',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20of%20a%20confident%20businessman%20in%20a%20tailored%20suit%2C%20standing%20in%20front%20of%20a%20modern%20skyscraper%2C%20golden%20hour%20lighting%2C%20success%20and%20ambition%20theme%2C%20digital%20illustration%20with%20warm%20golden%20tones%2C%20vertical%20composition%2C%20clean%20and%20powerful%20aesthetic&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    chapters_list: [
      { num: 156, title: '全球布局', date: '2026-06-30' },
      { num: 155, title: '收购大战', date: '2026-06-23' },
      { num: 154, title: '股市风云', date: '2026-06-16' },
      { num: 153, title: '暗箱操作', date: '2026-06-09' },
      { num: 152, title: '第二个机遇', date: '2026-06-02' },
      { num: 151, title: '危机公关', date: '2026-05-26' },
      { num: 150, title: '里程碑', date: '2026-05-19' },
      { num: 149, title: '资本博弈', date: '2026-05-12' },
    ],
    relatedIds: [5, 1, 3],
  },
  {
    id: 8,
    title: '魔法学徒日记',
    author: '安素英',
    status: '连载中',
    chapter: '更新至第89话',
    chapters: 89,
    tag: '奇幻',
    tagColor: 'secondary' as const,
    category: 'fantasy',
    description: '普通高中生林雨桐在图书馆发现一本古老的魔法书，从此打开了通往魔法世界的大门。作为魔法学院最差劲的学生，她连最简单的漂浮术都施展不出来。但她的体内似乎隐藏着一股连她自己都不知道的强大力量。当黑暗势力威胁魔法世界的平衡，这个最差劲的学徒却成了最后的希望。',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20young%20magic%20student%20with%20spell%20books%20floating%20around%2C%20magical%20sparks%20and%20runes%20glowing%2C%20fantasy%20academy%20background%20with%20ancient%20library%2C%20adventure%20and%20magic%20theme%2C%20digital%20art%20with%20warm%20magical%20glow%2C%20vertical%20orientation%2C%20enchanting%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    chapters_list: [
      { num: 89, title: '觉醒之力', date: '2026-07-01' },
      { num: 88, title: '黑暗来袭', date: '2026-06-24' },
      { num: 87, title: '古书之谜', date: '2026-06-17' },
      { num: 86, title: '学院大比', date: '2026-06-10' },
      { num: 85, title: '魔药课危机', date: '2026-06-03' },
      { num: 84, title: '禁林探险', date: '2026-05-27' },
      { num: 83, title: '新同伴', date: '2026-05-20' },
      { num: 82, title: '元素试炼', date: '2026-05-13' },
    ],
    relatedIds: [1, 6, 2],
  },
  {
    id: 9,
    title: '爆笑校园',
    author: '刘在石',
    status: '已完结',
    chapter: '全156话',
    chapters: 156,
    tag: '完结',
    tagColor: 'accent' as const,
    category: 'comedy',
    description: '以某高中二年三班为舞台，讲述了一群性格迥异的学生们鸡飞狗跳的校园日常。有中二病晚期的班长、永远在偷吃零食的体育委员、暗恋同桌却不敢表白的文艺委员……每个角色都充满了个性和笑点，让你笑到停不下来！',
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20Korean%20manhwa%20comedy%20illustration%20of%20funny%20high%20school%20students%20in%20classroom%2C%20exaggerated%20facial%20expressions%2C%20energetic%20and%20playful%20atmosphere%2C%20bright%20warm%20colors%2C%20cartoonish%20digital%20art%20style%2C%20vertical%20composition%2C%20hilarious%20school%20comedy%20theme&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    chapters_list: [
      { num: 156, title: '毕业典礼（终）', date: '2026-02-28' },
      { num: 155, title: '最后的文化祭', date: '2026-02-21' },
      { num: 154, title: '大学志愿', date: '2026-02-14' },
      { num: 153, title: '情人节大作战', date: '2026-02-07' },
    ],
    relatedIds: [10, 3, 5],
  },
  {
    id: 10,
    title: '恐怖公寓',
    author: '姜东元',
    status: '连载中',
    chapter: '更新至第34话',
    chapters: 34,
    tag: '惊悚',
    tagColor: 'accent' as const,
    category: 'horror',
    description: '搬进新公寓的第一天，尹秀雅就发现这里处处透着诡异：楼道里的脚步声、午夜时分的敲墙声、镜子里一闪而过的黑影……邻居们的眼神也充满秘密。这栋看似普通的公寓，究竟隐藏着怎样令人毛骨悚然的真相？',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20horror%20cover%20art%20of%20a%20dark%20eerie%20apartment%20building%20hallway%20with%20a%20single%20flickering%20light%2C%20shadowy%20figure%20at%20the%20end%20of%20corridor%2C%20creepy%20and%20atmospheric%2C%20digital%20art%20with%20dark%20tones%20and%20subtle%20warm%20highlights%2C%20vertical%20composition%2C%20psychological%20horror%20theme&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    chapters_list: [
      { num: 34, title: '地下室的秘密', date: '2026-06-28' },
      { num: 33, title: '101号房', date: '2026-06-21' },
      { num: 32, title: '监控录像', date: '2026-06-14' },
      { num: 31, title: '邻居的故事', date: '2026-06-07' },
    ],
    relatedIds: [6, 2, 8],
  },
  {
    id: 11,
    title: '总裁的契约新娘',
    author: '赵允儿',
    status: '已完结',
    chapter: '全98话',
    chapters: 98,
    tag: '完结',
    tagColor: 'secondary' as const,
    category: 'romance',
    description: '为偿还父亲的巨额债务，苏晚晴签下了一纸契约婚姻。她的丈夫是商界传奇——冷酷无情的顾氏集团总裁顾北辰。她以为这只是一场没有感情的商业交易，却在朝夕相处中，被这个男人的温柔一面所打动。而那个尘封多年的秘密，也即将浮出水面。',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20romantic%20drama%20cover%20art%20of%20an%20elegant%20couple%20in%20formal%20attire%2C%20man%20in%20dark%20suit%20and%20woman%20in%20white%20dress%2C%20dramatic%20tension%20between%20them%2C%20luxurious%20ballroom%20background%20with%20chandeliers%2C%20digital%20art%20with%20soft%20romantic%20tones%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    chapters_list: [
      { num: 98, title: '真爱之约（终）', date: '2026-01-15' },
      { num: 97, title: '最后的告白', date: '2026-01-08' },
      { num: 96, title: '误会冰释', date: '2026-01-01' },
      { num: 95, title: '危机解除', date: '2025-12-25' },
    ],
    relatedIds: [3, 5, 7],
  },
  {
    id: 12,
    title: '异界美食家',
    author: '王大陆',
    status: '连载中',
    chapter: '更新至第73话',
    chapters: 73,
    tag: '推荐',
    tagColor: 'primary' as const,
    category: 'fantasy',
    description: '米其林三星主厨穿越到剑与魔法的异世界，这里的食物简直难吃到令人发指！为了满足自己的味蕾，他决定用魔法食材重新演绎中华料理。没想到，「异界第一美食家」的名号不胫而走，连魔王都派人来请他做一顿年夜饭……',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20cooking%20illustration%20of%20a%20chef%20in%20fantasy%20world%2C%20magical%20ingredients%20floating%20around%2C%20steaming%20magical%20dishes%2C%20warm%20golden%20lighting%2C%20enchanting%20atmosphere%2C%20digital%20art%20style%20with%20rich%20warm%20colors%2C%20vertical%20composition%2C%20food%20and%20fantasy%20theme&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    chapters_list: [
      { num: 73, title: '魔王的盛宴', date: '2026-06-29' },
      { num: 72, title: '传说食材', date: '2026-06-22' },
      { num: 71, title: '龙肉料理', date: '2026-06-15' },
      { num: 70, title: '美食大赛', date: '2026-06-08' },
      { num: 69, title: '精灵之森', date: '2026-06-01' },
    ],
    relatedIds: [8, 1, 4],
  },
];

export const comicsByCategory: Record<string, number[]> = {
  romance: [3, 11],
  fantasy: [1, 8, 12],
  action: [2, 4],
  suspense: [6],
  comedy: [9],
  rebirth: [7],
  workplace: [5],
  horror: [10],
};